export default "__VITE_ASSET__BfH3wvgj__";